import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Card, Row, Col, Modal, Button, Badge, InputGroup, Form, FormLabel, CloseButton } from 'react-bootstrap';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/es';
import classNames from 'classnames';
import { getCoreRowModel } from '@tanstack/react-table';
import { getExpandedRowModel } from '@tanstack/react-table';
import { useReactTable } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';
import { getPaginationRowModel } from '@tanstack/react-table';
import { getFilteredRowModel } from '@tanstack/react-table';
import { GoogleMapsProvider } from '../../../../../providers/GoogleMapsProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from '../../../../../components/common/IconButton';
import { faExternalLinkAlt, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import GoogleMapSelector, { iconPuntoF, iconPuntoI } from '../../../../../components/common/google-maps-selector/GoogleMapSelector';
import AlertaVehiculoTableList from '../table-alerts/table-alerts';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaFileExport, FaMapMarkerAlt } from 'react-icons/fa';
import iconoPng from '../../../../../assets/img/icons/export.png';
import Spinner from 'react-bootstrap/Spinner';
import * as XLSX from 'xlsx';
import './master-detail-table.css';
import { obtenerIconoEvento } from '../../../../../components/common/google-maps-selector/IconosTabla';
import { ReporteRecorridoService } from '../../../../../services/apiService';
import { QURO_MAP_CONFIG } from '../../../../../config/apiConfig';
import { generateExcelReport } from '../../../../../helpers/createExcelReport';
import { obtenerLinkMapa } from '../../../../../helpers/utils';

// Activamos el soporte para formatos personalizados
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('es');

// const formatFecha = (fechaStr) => {
//   if (!fechaStr || typeof fechaStr !== "string") return "N/A";
//   try {
//     // Cambio de 'hh' a 'HH' para formato de 24 horas
//     return dayjs.utc(fechaStr).local().format("DD/MM/YYYY HH:mm");

//     // O si prefieres mantener AM/PM pero corregir la conversión:
//     // return dayjs.utc(fechaStr).local().format("DD/MM/YYYY h:mm A");
//   } catch (error) {
//     console.error("Error al formatear la fecha:", error);
//     return "N/A";
//   }
// };

// const formatFecha = (fechaStr) => {
//     if (!fechaStr || typeof fechaStr !== 'string') return ' ';
//     const fecha = new Date(fechaStr);
//     const offset = new Date().getTimezoneOffset() * 60000; // Obtener offset en milisegundos
//     const fecha_inicio = new Date(fecha.getTime() - offset).toISOString();
//     try {
//         return dayjs(fecha_inicio, 'YYYY/MM/DD/ HH:mm:ss').format('DD/MM/YYYY HH:mm A');
//     } catch (error) {
//         console.error('Error al formatear la fecha:', error);
//         return 'N/A';
//     }
// };

const formatFecha = (fechaStr) => {
    if (!fechaStr || typeof fechaStr !== 'string') return 'N/A';

    try {
        return dayjs(fechaStr, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm');
    } catch (error) {
        console.error('Error al formatear la fecha:', error);
        return 'N/A';
    }
};

const tiposVistaFechas = [
    {
        value: 0,
        inicio: "Inicio alerta detenido",
        fin: "Fin alerta detenido",
    },
    {
        value: 1,
        inicio: "Fecha encendido",
        fin: "Fecha apagado",
    },
    {
        value: 2,
        inicio: "Inicio detenido",
        fin: "Fin detenido",
    }
];
const MasterTableUsability = ({ data = [], title, isGroup, geocercas = [], searchValue = '', onSearch, pageSize = 100, isExporting = false, onExport, }) => {
    // Personalizar la vista del Select
    const customStyles = {
        minWidth: '70px',
        minHeight: '30px',
        maxHeight: '30px',
        fontSize: '12px',
        overflow: 'hidden',
        appearance: 'none',
        WebkitAppearance: 'none',
        MozAppearance: 'none',
        backgroundColor: 'white',
        border: '1px solid #ccc',
        paddingRight: '20px',
        paddingLeft: '10px',
        backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='lightgrey' viewBox='0 0 24 24'><path d='M12 15.41 6.41 9.83 7.83 8.41 12 12.59 16.17 8.41 17.59 9.83z'/></svg>")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 5px center',
        backgroundSize: '25px',
    };
    /*
    <button
                            onClick={row.getToggleExpandedHandler()}
                            style={{ cursor: 'pointer' }}
                        >
                            {row.getIsExpanded() ? '➖' : '➕'}
                        </button>
    */
    const safeTableData = Array.isArray(data) ? data : [];

    // Estado para manejar el modal del mapa
    const [globalFilter, setGlobalFilter] = useState(searchValue);
    const [inputValue, setInputValue] = useState(searchValue);
    const debounceTimeout = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [showAlertasModal, setShowAlertasModal] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [track, setTrack] = useState([]);
    const [markers, setMarkers] = useState([]);
    const [selectedVehicleAlerts, setSelectedVehicleAlerts] = useState([]);
    // Mapa para asignar colores a cada tipo de alerta
    const alertColorsRef = useRef(new Map());
    const usedColors = new Set();

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: pageSize,
    });

    const [tokenQuro, setTokenQuro] = useState('');
    const [fechaInicial, setFechaInicial] = useState(Date.now());
    const [fechaFinal, setFechaFinal] = useState(Date.now());
    const [idVehiculo, setIdVehiculo] = useState(0);
    const [uidVehiculo, setUidVehiculo] = useState('');

    // Función para filtrar datos manualmente
    const getFilteredData = useMemo(() => {
        if (!globalFilter || globalFilter.trim() === '') {
            return safeTableData;
        }

        const searchValue = globalFilter.toLowerCase().trim();
        console.log('🔍 Iniciando búsqueda con valor:', searchValue);
        console.log('📊 Datos originales:', safeTableData.length, 'filas');

        // Función para verificar si una fila o sus hijos coinciden
        const hasMatch = (rowData) => {
            // Buscar en campos específicos
            const fieldsToSearch = [
                'vehiculo', 'fechaInicio', 'fechaFin', 'tiempo',
                'distancia', 'usabilidad', 'tiempoEncendido',
                'tiempoDetenido', 'tiempoApagado', 'horas', 'totalAlertas'
            ];

            for (const field of fieldsToSearch) {
                if (rowData[field] !== undefined && rowData[field] !== null) {
                    const fieldValue = String(rowData[field]).toLowerCase();
                    if (fieldValue.includes(searchValue)) {
                        console.log(`✅ Match directo en campo "${field}": "${rowData[field]}" para búsqueda "${searchValue}"`);
                        return true;
                    }

                    // Buscar también en formato formateado para campos específicos
                    if (field === 'distancia') {
                        const formattedValue = `${(rowData[field] || 0).toFixed(2)} km`.toLowerCase();
                        if (formattedValue.includes(searchValue)) {
                            console.log(`✅ Match en distancia formateada: "${formattedValue}" para búsqueda "${searchValue}"`);
                            return true;
                        }
                    }

                    if (field === 'tiempoEncendido' || field === 'tiempoDetenido' || field === 'tiempoApagado') {
                        const hrs = String(Math.floor(rowData[field])).padStart(2, '0');
                        const min = String(Math.floor(((rowData[field] % 1) * 60))).padStart(2, '0');
                        const formattedValue = `${hrs}.${min} hr(s)`.toLowerCase();
                        if (formattedValue.includes(searchValue)) {
                            console.log(`✅ Match en tiempo formateado: "${formattedValue}" para búsqueda "${searchValue}"`);
                            return true;
                        }
                    }

                    // Buscar en el campo 'tiempo' que se muestra en la columna Tiempo
                    if (field === 'tiempo') {
                        const formattedValue = `${rowData[field]} hr(s)`.toLowerCase();
                        if (formattedValue.includes(searchValue)) {
                            console.log(`✅ Match en tiempo general formateado: "${formattedValue}" para búsqueda "${searchValue}"`);
                            return true;
                        }
                    }

                    if (field === 'usabilidad') {
                        const formattedValue = `${rowData[field]}%`.toLowerCase();
                        if (formattedValue.includes(searchValue)) {
                            console.log(`✅ Match en usabilidad formateada: "${formattedValue}" para búsqueda "${searchValue}"`);
                            return true;
                        }
                    }

                    // Buscar en el formato de porcentaje que se muestra en las columnas principales
                    if (field === 'tiempoEncendido' || field === 'tiempoDetenido' || field === 'tiempoApagado') {
                        const percentage = Math.round((rowData[field] / rowData.horas) * 100);
                        const formattedPercentage = `${percentage}%`.toLowerCase();
                        if (formattedPercentage.includes(searchValue)) {
                            console.log(`✅ Match en porcentaje formateado: "${formattedPercentage}" para búsqueda "${searchValue}"`);
                            return true;
                        }
                    }

                    if (field === 'fechaInicio' || field === 'fechaFin') {
                        try {
                            const formattedValue = formatFecha(rowData[field]).toLowerCase();
                            if (formattedValue.includes(searchValue)) {
                                console.log(`✅ Match en fecha formateada: "${formattedValue}" para búsqueda "${searchValue}"`);
                                return true;
                            }

                            // También buscar en el formato con "hr(s)" que se muestra en las columnas
                            const formattedWithHrs = `${formattedValue} hr(s)`.toLowerCase();
                            if (formattedWithHrs.includes(searchValue)) {
                                console.log(`✅ Match en fecha con hr(s): "${formattedWithHrs}" para búsqueda "${searchValue}"`);
                                return true;
                            }
                        } catch (error) {
                            // Si falla el formateo, continuar con el valor original
                        }
                    }
                }
            }

            // Buscar en todos los campos
            for (const key in rowData) {
                if (rowData.hasOwnProperty(key) && rowData[key] !== undefined && rowData[key] !== null) {
                    const value = String(rowData[key]).toLowerCase();
                    if (value.includes(searchValue)) {
                        return true;
                    }
                }
            }

            return false;
        };

        // Filtrar filas que coincidan o tengan hijos que coincidan
        return safeTableData.map(row => {
            // Si la fila principal coincide, devolverla completa
            if (hasMatch(row)) {
                return row;
            }

            // Si tiene hijos, verificar si algún hijo coincide
            if (row.children && Array.isArray(row.children)) {
                const matchingChildren = row.children.filter(child => hasMatch(child));
                if (matchingChildren.length > 0) {
                    console.log(`🔍 Fila "${row.vehiculo}": ${matchingChildren.length} subrows coinciden de ${row.children.length} total`);
                    matchingChildren.forEach((child, index) => {
                        console.log(`  ✅ Subrow ${index + 1}: ${child.fechaInicio} - ${child.fechaFin} (${child.distancia} km)`);
                    });
                    // Crear una nueva fila con solo los hijos que coinciden
                    return {
                        ...row,
                        children: matchingChildren
                    };
                }
            }

            return null;
        }).filter(row => row !== null);

        console.log('🔍 Resultado del filtrado:', filteredData.length, 'filas encontradas');
        return filteredData;
    }, [safeTableData, globalFilter]);

    // Debug: Mostrar estructura de datos cuando cambia
    useEffect(() => {
        console.log('📊 Estructura de datos de la tabla:', safeTableData);
        console.log('🔍 Datos filtrados:', getFilteredData);
        if (safeTableData.length > 0 && safeTableData[0].children) {
            console.log('📊 Ejemplo de subrow:', safeTableData[0].children[0]);
        }
    }, [safeTableData, getFilteredData]);
    const obtenerTokenQuro = async () => {

        const response = await ReporteRecorridoService.getTokenConexionQuro()
        if (response && response.statusCode === 200) {

            if (response.data != null && response.data.length != 0) {
                setTokenQuro(response.data)
            } else {

                setTokenQuro('')
            }

        }
    }

    const handleClickAbrirRecorrido = () => {

        obtenerTokenQuro()
    }

    useEffect(() => {
        if (tokenQuro.length > 0) {
            const _fechaCargaInicial = dayjs(fechaInicial).format('YYYY-MM-DDTHH:mm:ss')
            const _fechaUltimaCarga = dayjs(fechaFinal).format('YYYY-MM-DDTHH:mm:ss')
            const _redirect = `Uid=${uidVehiculo}&fecha_carga_inicia=${_fechaCargaInicial}&Fecha_Ultima_Carga=${_fechaUltimaCarga}`

            const mapUrl = obtenerLinkMapa(_redirect, QURO_MAP_CONFIG.BASE_URL);
            if (mapUrl) {
                window.open(mapUrl);
            }
        }
    }, [tokenQuro])

    // Función para abrir el modal con la latitud y longitud seleccionadas
    const handleShowMap = (track, markers, points) => {
        if (track !== undefined) {
            if (points.children) {
                setFechaInicial(dayjs(points.children[0].fechaInicio, 'YYYY/MM/DD HH:mm:ss'));
                setFechaFinal(dayjs(points.children[points.children.length - 1].fechaFin, 'YYYY/MM/DD HH:mm:ss'));
            } else {
                setFechaInicial(dayjs(points.fechaInicio, 'YYYY/MM/DD HH:mm:ss'));
                setFechaFinal(dayjs(points.fechaFin, 'YYYY/MM/DD HH:mm:ss'));
            }
            setIdVehiculo(points.vehiculoId)
            setUidVehiculo(points.vehiculoUid)
            setSelectedLocation({ ...track[0], zoomLevel: 14 });
            setTrack(track);
            /*
                        setMarkers(markers.map((m, index) => {
                            let iconoruta = index === 0 ? obtenerIconoEvento(99993) : (index === data.length - 1 ? obtenerIconoEvento(99994) : m.icon || null);
                            return ({ ...m, icon: iconoruta });
                        }));*/
            setMarkers(markers);
            setShowMapModal(true);
        }
    };

    // Estructura de columnas 
    const TabTitle = ({ amount, percentage, type, updown, action, width }) => (
        <div className="d-flex flex-nowrap justify-content-sm-between">
            <span className="fw-bold label-detail-card pt-1 " style={{ minWidth: width || '90px' }}>{amount}</span>
            {/* text-600 */}
            { /* <FontAwesomeIcon
                icon={(updown === undefined ? percentage : updown >= 0) ? 'caret-up' : 'caret-down'}
                className={classNames('mx-1', {
                    'text-alert-movement': type === 'up',
                    'text-alert-off': type === 'down',
                    'text-primary': type === 'standard',
                    'text-alert-detained': type === 'warning',
                    'text-info': type === 'pending'
                })}
            />*/}
            <span
                className={classNames('fw-bold label-detail-card fs-11 pt-1 mb-0 text-nowrap', {
                    'text-alert-movement': type === 'up',
                    'text-alert-off': type === 'down',
                    'text-primary': type === 'standard',
                    'text-alert-detained': type === 'warning',
                    'text-info': type === 'pending'
                })} style={{ flex: '0 1 auto' }}
            >

                <Badge style={{ width: 60, height: 30 }} pill bg="transparent" className={`fw-semibold label-detail-card`}>
                    <a
                        className={classNames('mx-1 fw-semibold label-detail-card', {
                            'text-alert-movement': type === 'up',
                            'text-alert-off': type === 'down',
                            'text-primary': type === 'standard',
                            'text-alert-detained': type === 'warning',
                            'text-info': type === 'pending'
                        })}
                        href="#!" onClick={action}
                    >
                        {percentage}
                    </a>
                </Badge>

            </span>
        </div>
    );
    const style1Lines = {
        display: "-webkit-box",
        WebkitLineClamp: 1,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    const columns = [
        {
            header: ' ',
            cell: ({ row }) => {
                return row.getCanExpand() ?
                    <div>
                        <IconButton
                            variant="falcon-default"
                            size="sm"
                            icon={row.getIsExpanded() ? "chevron-up" : "chevron-down"}
                            transform="shrink-3"
                            onClick={row.getToggleExpandedHandler()}
                        />
                    </div>
                    :
                    <div style={{ width: 42, maxWidth: 42 }} />;
            },
        },
        {
            accessorKey: 'vehiculo',
            header: 'Vehículo',
            cell: ({ row }) => {
                // className="text-800"
                return row.getCanExpand() ? <Row>
                    <Col className="fw-bold label-detail-card pt-1">
                        <span
                            style={{ ...style1Lines, minWidth: '80px' }}
                            title={row.original.vehiculo} >
                            {row.original.vehiculo}
                        </span>
                    </Col>
                </Row> : <div></div>;
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'fechaInicio',
            header: 'Usabilidad',
            cell: ({ row }) => {
                return row.getCanExpand() ?
                    <Row className="pt-1 flex-nowrap ">
                        <span className='fw-bold label-detail-card text-nowrap mx-0' style={{ width: '200px' }}
                            // text-800
                            title={row.original.tiempo} >
                            {row.original.tiempo}
                        </span>
                        <Badge style={{ width: 60, height: 30 }} pill bg="transparent" className={` mx-0 fw-semibold label-detail-card text-${'info'.split('-')[1] || 'info'}`}>
                            {row.original.usabilidad}%
                        </Badge>
                    </Row>
                    :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span> Encendido </span>
                            </Col>
                        </Row> :
                        <Row style={{ width: '240px' }}>
                            <Col>
                                <span className='label-detail-card'>
                                    {/* className="text-600" */}
                                    {formatFecha(row.original.fechaInicio)} hr(s)
                                </span>
                            </Col>
                        </Row>
                    ;
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'fechaFin',
            header: 'En Movimiento',
            cell: ({ row }) => {
                let hrs = String(Math.floor(row.original.tiempoEncendido)).padStart(2, '0');
                let min = String(Math.floor(((row.original.tiempoEncendido % 1) * 60))).padStart(2, '0');
                return row.getCanExpand() ?
                    <Row md={12} className="flex-nowrap" style={{ maxWidth: '200px' }}>

                        <TabTitle
                            amount={`${hrs}.${min} hr(s)`}
                            percentage={`${Math.round((row.original.tiempoEncendido / row.original.horas) * 100)}%`}
                            type='up'
                        />
                    </Row>
                    :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span> Apagado </span>
                            </Col>
                        </Row> :
                        <Row style={{ width: '240px' }}>
                            <Col >
                                <span className='label-detail-card'>
                                    {/* className="text-600"  */}
                                    {formatFecha(row.original.fechaFin)} hr(s)
                                </span>
                            </Col>
                        </Row>;
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'tiempo',
            header: 'Detenido',
            cell: ({ row }) => {
                let hrs = String(Math.floor(row.original.tiempoDetenido)).padStart(2, '0');
                let min = String(Math.floor(((row.original.tiempoDetenido % 1) * 60))).padStart(2, '0');
                // LOG: Mostrar datos usados para el cálculo de tiempo detenido
                //console.log('Detenido - row.original:', row.original);
                return row.getCanExpand() ?
                    <Row style={{ maxWidth: '200px' }}>
                        <Col className="fw-normal">
                            <TabTitle
                                amount={`${hrs}.${min} hr(s) `}
                                percentage={`${Math.round((row.original.tiempoDetenido / row.original.horas) * 100)}%`}
                                type='warning'
                            />
                        </Col>
                    </Row>
                    :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span> Tiempo </span>
                            </Col>
                        </Row> :
                        <Row>
                            <Col >
                                <span className='label-detail-card'>
                                    {/* className="text-600" */}
                                    {row.original.tiempo}
                                </span>
                            </Col>
                        </Row>;
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: 'distancia',
            header: 'Motor Apagado',
            cell: ({ row }) => {
                // LOG: Mostrar datos usados para el cálculo de distancia
                //console.log('Motor Apagado - row.original:', row.original);
                let hrs = String(Math.floor(row.original.tiempoApagado)).padStart(2, '0');
                let min = String(Math.floor(((row.original.tiempoApagado % 1) * 60))).padStart(2, '0');
                return row.getCanExpand() ?
                    <Row style={{ maxWidth: '200px' }}>
                        <Col className="fw-bold" style={{ fontWeight: 'bold' }}>
                            <TabTitle
                                amount={`${hrs}.${min} hr(s) `}
                                percentage={`${((row.original.tiempoApagado / row.original.horas) * 100).toFixed(0)}%`}
                                type='down'
                                updown={-1}
                            />
                        </Col>
                    </Row>
                    :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span>Distancia</span>
                            </Col>
                        </Row> :
                        <Row>
                            <Col >
                                <span className='label-detail-card'>
                                    {/* className="text-600"  */}
                                    {parseFloat(`${row.original.distancia}`).toFixed(2)} km
                                </span>
                            </Col>
                        </Row>;
            },
            meta: { headerProps: { className: 'text-900' } }
        },
        {
            accessorKey: "mapa",
            header: "Distancia Recorrida",
            cell: ({ row }) => {
                // ✅ LOGS DE DEBUG PARA DISTANCIA
                // console.log('🔍 DEBUG Distancia Recorrida:', {
                //     vehiculo: row.original.vehiculo,
                //     isExpanded: row.getCanExpand(),
                //     distanciaRaw: row.original.distancia,
                //     distanciaType: typeof row.original.distancia,
                //     distanciaString: `${row.original.distancia}`,
                //     distanciaFixed: (row.original.distancia).toFixed(3),
                //     totalKM: row.original.totalKM,
                //     originalCompleto: row.original
                // });

                return row.getCanExpand() ?
                    <Row>
                        <Col className="fw-bold">
                            <TabTitle
                                amount={`${(row.original.distancia || 0).toFixed(2)} km`}
                                percentage={'Ver'}
                                type='pending'
                                action={() => handleShowMap(
                                    row.original.track ?? [],
                                    row.original.markers,
                                    row.original
                                )}
                                width={"10px"}
                            />
                        </Col>
                    </Row>
                    :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span>
                                </span>
                            </Col>
                        </Row> :
                        <div className='text-center'>
                            <a
                                size="sm"
                                className="p-1"
                                href='#!'
                                transform="shrink-3"
                                onClick={() => handleShowMap(
                                    row.original.track ?? [],
                                    [],
                                    row.original
                                )}
                            >
                                <FaMapMarkerAlt className="text-danger" />
                            </a>
                        </div>;
            },
            meta: {
                headerProps: { className: "text-900 text-center" },
                cellProps: { className: "text-center" },
            },
        },
        // {
        //     accessorKey: "mapa",
        //     header: "Distancia Recorrida",
        //     cell: ({ row }) => {
        //         // LOG: Mostrar datos usados para el cálculo de distancia recorrida
        //         console.log('Distancia Recorrida - row.original:', row.original);
        //         return row.getCanExpand() ?
        //             <Row>
        //                 <Col>
        //                     <TabTitle
        //                         amount={`${(row.original.distancia).toFixed(3)} KM`}
        //                         percentage={'Abrir'}
        //                         type='pending'
        //                         action={() => handleShowMap(
        //                             row.original.track ?? [],
        //                             row.original.markers
        //                         )}
        //                     />
        //                 </Col>
        //             </Row>
        //             :
        //             <div className='text-center'>
        //                 <a
        //                     size="sm"
        //                     className="p-1"
        //                     href='#!'
        //                     transform="shrink-3"
        //                     onClick={() => handleShowMap(
        //                         row.original.track ?? [],
        //                         []
        //                     )}
        //                 >
        //                     <FaMapMarkerAlt className="text-danger" />

        //                 </a>
        //             </div>;
        //     },
        //     meta: {
        //         headerProps: { className: "text-900 text-center" },
        //         cellProps: { className: "text-center" },
        //     },
        // },
        {
            accessorKey: "totalAlertas",
            header: "Alertas",
            cell: ({ row }) => {
                return row.getCanExpand() ?
                    <Row href="#!">
                        <Col style={{ fontWeight: 'bold' }} className="fw-bold">
                            <TabTitle
                                amount={`${row.original.totalAlertas.length}`}
                                percentage={'Ver'}
                                updown={1}
                                type='pending'
                                action={() => {
                                    setSelectedVehicleAlerts(row.original.totalAlertas);
                                    setShowAlertasModal(true);
                                }}
                                width={'40px'}
                            />
                        </Col>
                    </Row>
                    :
                    row.original.header === true ?
                        <Row>
                            <Col className="fw-bold label-detail-card pt-1">
                                <span>
                                </span>
                            </Col>
                        </Row> :
                        '';
            },
            meta: {
                headerProps: { className: "text-900 text-center" },
                cellProps: { className: "text-center", },
            },
        }
    ]



    const table = useReactTable({
        data: getFilteredData, // Usar datos filtrados manualmente
        columns,
        sortable: true,
        pagination: true,
        state: {
            pagination,
            expanded,
        },
        onPaginationChange: setPagination,
        onExpandedChange: setExpanded,
        getPaginationRowModel: getPaginationRowModel(),
        getCoreRowModel: getCoreRowModel(),
        getSubRows: (row) => row.children,
        getExpandedRowModel: getExpandedRowModel(),
        enableSorting: true,
        enableGlobalFilter: false, // Desactivar filtro global de React Table
        debugTable: false,
        enableColumnFilters: false,
    });

    // Manejar el cambio en la búsqueda global
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
        debounceTimeout.current = setTimeout(() => {
            setGlobalFilter(value);
            if (onSearch) onSearch(value);
            setPagination(prev => ({ ...prev, pageIndex: 0 }));
            // Si hay un valor de búsqueda, expandir automáticamente las filas que contienen resultados
            if (value && value.trim() !== '') {
                const expandedRows = {};
                getFilteredData.forEach((row, index) => {
                    expandedRows[index] = true;
                });
                setExpanded(expandedRows);
            } else {
                setExpanded({});
            }
        }, 400);
    };

    // Sincronizar el filtro global con el searchValue recibido por props
    React.useEffect(() => {
        setGlobalFilter(searchValue);

        // Si hay un valor de búsqueda, expandir automáticamente las filas que contienen resultados
        if (searchValue) {
            const expandedRows = {};
            getFilteredData.forEach((row, index) => {
                expandedRows[index] = true; // Expandir todas las filas filtradas
            });
            setExpanded(expandedRows);
        } else {
            // Si no hay búsqueda, colapsar todas las filas
            setExpanded({});
        }
    }, [searchValue, getFilteredData]);

    const Filter = function ({ column, table }) {
        const firstValue = table
            .getPreFilteredRowModel()
            .flatRows[0]?.getValue(column.id)
        const columnFilterValue = column.getFilterValue()

        return typeof firstValue === "number" ? (
            <div className="flex space-x-2">
                <input
                    type="number"
                    value={columnFilterValue?.[0] ?? ""}
                    onChange={e => column.setFilterValue(old => [e.target.value, old?.[1]])}
                    placeholder={`Min`}
                    className="w-24 border shadow rounded"
                />
            </div>
        ) : (
            <input
                type="text"
                value={columnFilterValue ?? ""}
                onChange={e => column.setFilterValue(e.target.value)}
                placeholder={`Search...`}
                className="w-36 border shadow rounded"
            />
        )
    }

    const getUniqueColor = () => {
        let newColor;
        do {
            newColor = `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
        } while (usedColors.has(newColor)); // Asegurar que el color no esté en uso
        usedColors.add(newColor);
        return newColor;
    };

    const getAlertColor = (alertType) => {
        if (!alertColorsRef.current.has(alertType)) {
            const newColor = getUniqueColor();
            alertColorsRef.current.set(alertType, newColor);
        }
        return alertColorsRef.current.get(alertType);
    };

    const handleExportToExcel = async () => {

        try {
            if (window['guardarBitacoraExport']) {
                try {
                    window['guardarBitacoraExport']();
                } catch (error) {

                }
            }

            //Columnas del reporte 
            let columns = [
                'Vehiculo',
                'Fecha Inicio',
                'Fecha Fin',
                'Tiempo',
                'Distancia'
            ]

            // Agregar maestro-detalle 
            let dataReport = [];

            safeTableData.forEach((grupo, index) => {

                //Detallado por vehiculo 
                let subList = [];

                // Filas de detalles
                grupo.children.forEach(detalle => {

                    const distancia = parseFloat(detalle.distancia?.toString() || 0).toFixed(2).toString() + ' Km';

                    subList.push([
                        detalle.vehiculo?.toString() || "N/A",
                        detalle.fechaInicio?.toString() || "N/A",
                        detalle.fechaFin?.toString() || "N/A",
                        detalle.tiempo?.toString() || "N/A",
                        distancia || "N/A",
                    ]);
                });

                //maestro
                let masterData =
                {
                    titulo: `Vehiculo: (${grupo.vehiculo})  |  Tiempo Usabilidad:  ${grupo.tiempo} `,
                    detalles: subList
                }

                //Agrega el maestro a la lista de informacion
                dataReport.push(masterData);
            });

            //Exportar reporte 
            generateExcelReport('Reporte Tiempos', dataReport, true, columns);

        } catch (error) {
            console.error("Error al exportar a Excel:", error);
        }
    };

    return (
        <Card className="h-100" >
            <Card.Header>

                <Row className='d-flex align-items-center justify-content-between'>
                    <Col md={6}>
                        <h6 className="mb-0 text-nowrap py-2 py-xl-0">{title}</h6>
                    </Col>

                    <Col md={4} className="d-flex justify-content-end align-items-center">

                        <Button
                            variant="primary"
                            size="sm"
                            className="me-2 p-2"
                            onClick={handleExportToExcel}
                            disabled={isExporting}
                        >
                            {isExporting ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-1"
                                    />
                                    Exportando...
                                </>
                            ) : (
                                <>
                                    <img
                                        src={iconoPng}
                                        alt="Exportar" title='Exportar a Excel'
                                        style={{ width: '20px', height: '20px', filter: 'brightness(0) invert(1)' }} // Ajusta el tamaño
                                        className="me-1 ms-1"
                                    />
                                </>
                            )}
                        </Button>

                        <InputGroup size="sm" style={{ maxWidth: 200 }} >

                            <Form.Control
                                className='p-2'
                                type="text"
                                placeholder="Buscar..."
                                value={inputValue || ''}
                                onChange={handleSearchChange}
                            />
                            {globalFilter && (
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setGlobalFilter('');
                                        if (onSearch) onSearch('');
                                    }}
                                >
                                    &times;
                                </Button>
                            )}

                        </InputGroup>

                    </Col>

                    <Col md={2}>
                        <Form className='d-flex p-2 justify-content-end'>
                            <Form.Select
                                className='p-2'
                                size="sm"
                                style={{ width: '100px' }}
                                value={table.getState().pagination.pageSize}
                                onChange={e => {
                                    table.setPageSize(Number(e.target.value))
                                }}
                            >
                                {[5, 10, 20, 30, 40, 50].map(pageSize => (
                                    <option key={pageSize} value={pageSize}>
                                        {pageSize}
                                    </option>
                                ))}
                            </Form.Select>

                        </Form>
                    </Col>
                </Row>
            </Card.Header>

            <Card.Body className='mt-0 pt-0 ms-0 me-0 ps-0 pe-0'>
                <div style={{ overflow: 'auto' }}>
                    <GoogleMapsProvider>
                        <table className='fs-10 mb-0 overflow-hidden table table-striped'>
                            <thead className='text-nowrap align-middle'>
                                {table.getHeaderGroups().map(headerGroup => (
                                    <tr key={headerGroup.id}>
                                        {headerGroup.headers.map(header => {
                                            return (
                                                <th key={header.id} colSpan={header.colSpan}>
                                                    {header.isPlaceholder ? null : (
                                                        <div>
                                                            {flexRender(
                                                                header.column.columnDef.header,
                                                                header.getContext()
                                                            )}

                                                            {header.column.getCanFilter() ? (
                                                                <div>
                                                                    <Filter column={header.column} table={table} />
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    )}
                                                </th>
                                            )
                                        })}
                                    </tr>
                                ))}
                            </thead>
                            <tbody>
                                {table.getRowModel().rows.map(row => {
                                    return (
                                        <tr key={row.id} className={row.original.fueraDeHorario === true ? 'fondo-tabla-danger' : ''}>
                                            {row.getVisibleCells().map(cell => {
                                                return (
                                                    <td key={cell.id}>
                                                        {flexRender(
                                                            cell.column.columnDef.cell,
                                                            cell.getContext()
                                                        )}
                                                    </td>
                                                )
                                            })}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>

                        {/* Modal para ver el mapa */}
                        <Modal
                            show={showMapModal}
                            onHide={() => setShowMapModal(false)}
                            size="lg"
                            centered
                        >
                            <Modal.Header className="d-flex justify-content-between align-items-center" >
                                <Modal.Title className="mb-0">
                                    Recorrido
                                </Modal.Title>

                                <div className='d-flex align-items-center gap-2'>
                                    <Button
                                        variant="outline-primary"
                                        size="sm"
                                        style={{
                                            backgroundColor: 'white',
                                            color: '#2c7be5'
                                        }}
                                        onClick={handleClickAbrirRecorrido}
                                    >
                                        <FontAwesomeIcon icon={faExternalLinkAlt} /> Abrir recorrido
                                    </Button>
                                    <CloseButton onClick={() => setShowMapModal(false)} />
                                </div>

                            </Modal.Header>
                            <Modal.Body>
                                <GoogleMapSelector
                                    className="vh-50"
                                    mapStyle="Default"
                                    initialCenter={selectedLocation}
                                    waypoints={track}
                                    markers={markers}
                                    geocercas={geocercas}
                                    zoomDefault={13}
                                    showStreetView={false}
                                />
                            </Modal.Body>
                        </Modal>

                        <Modal Modal
                            show={showAlertasModal}
                            onHide={() => setShowAlertasModal(false)}
                            size="xl"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Listado de Alertas GPS</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className='mt-0 pt-0 ms-0 me-0 ps-0 pe-0'>
                                <Col md={12}>
                                    {selectedVehicleAlerts.length > 0 && (
                                        <AlertaVehiculoTableList
                                            data={selectedVehicleAlerts.map(alert => ({
                                                ...alert,
                                                color: getAlertColor(alert.alerta) // Color persistente por alerta
                                            }))}
                                            title="Listado Alertas GPS"
                                            isGroup={true}
                                            perPage={5}
                                            geocercas={geocercas}
                                        />)
                                    }
                                </Col>
                            </Modal.Body>
                        </Modal>
                    </GoogleMapsProvider>
                </div>
            </Card.Body>

            <Card.Footer className="bg-white">


                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div className="d-flex align-items-center">
                        <span className="me-2">
                            Total: {table.getFilteredRowModel().rows.length} | Página {table.getState().pagination.pageIndex + 1} de {table.getPageCount()}
                        </span>
                        <Form.Control
                            type="number"
                            min="1"
                            max={table.getPageCount()}
                            value={table.getState().pagination.pageIndex + 1}
                            onChange={e => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                table.setPageIndex(page);
                            }}
                            style={{ width: '70px', height: '31px' }}
                            size="sm"
                        />
                    </div>

                    <div className="d-flex justify-content-center">
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.setPageIndex(0)}
                            disabled={!table.getCanPreviousPage()}
                        >
                            <FaAngleDoubleLeft />
                            {/* &laquo; Primera */}
                        </Button>
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.previousPage()}
                            disabled={!table.getCanPreviousPage()}
                        >
                            <FaAngleLeft />
                            {/* &lt; Anterior */}
                        </Button>

                        {/* Mostrar números de página (5 páginas alrededor de la actual) */}
                        {(() => {
                            // Determinar qué páginas mostrar
                            let pagesArray = [];
                            if (table.getPageCount() <= 5) {
                                // Si hay 5 o menos páginas, mostrarlas todas
                                pagesArray = Array.from({ length: table.getPageCount() }, (_, i) => i);
                            } else if (table.getState().pagination.pageIndex <= 2) {
                                // Si estamos en las primeras páginas
                                pagesArray = [0, 1, 2, 3, 4];
                            } else if (table.getState().pagination.pageIndex >= table.getPageCount() - 3) {
                                // Si estamos en las últimas páginas
                                pagesArray = [
                                    table.getPageCount() - 5,
                                    table.getPageCount() - 4,
                                    table.getPageCount() - 3,
                                    table.getPageCount() - 2,
                                    table.getPageCount() - 1
                                ];
                            } else {
                                // Estamos en medio, mostrar 2 antes y 2 después
                                pagesArray = [
                                    table.getState().pagination.pageIndex - 2,
                                    table.getState().pagination.pageIndex - 1,
                                    table.getState().pagination.pageIndex,
                                    table.getState().pagination.pageIndex + 1,
                                    table.getState().pagination.pageIndex + 2
                                ];
                            }

                            return pagesArray.map(pageNum => (
                                <Button
                                    key={`page-${pageNum}`}
                                    variant={pageNum === table.getState().pagination.pageIndex ? "primary" : "outline-dark"}
                                    size="sm"
                                    className="mx-1"
                                    onClick={() => table.setPageIndex(pageNum)}
                                >
                                    {pageNum + 1}
                                </Button>
                            ));
                        })()}

                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.nextPage()}
                            disabled={!table.getCanNextPage()}
                        >
                            {/* Siguiente &gt; */}
                            <FaAngleRight />
                        </Button>
                        <Button
                            variant="outline-dark"
                            size="sm"
                            className="mx-1"
                            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                            disabled={!table.getCanNextPage()}
                        >
                            {/* Última &raquo; */}
                            <FaAngleDoubleRight />
                        </Button>
                    </div>
                </div>

                {/* <div>

                    <Row className='justify-content-center'>
                        <Col className='flex-grow-1 mt-2'>
                            <div className='d-flex align-items-center fs-10'>

                                <p className='mb-0'>

                                    <span className="d-sm-inline-block me-2">
                                        <strong>
                                            {table.getState().pagination.pageIndex + 1} - {' '}
                                            {table.getPageCount()} de {data.length}
                                        </strong>
                                    </span>
                                </p>


                                <p className="mb-0 mx-2">Página: </p>

                                <span className="flex items-center gap-1">
                                    <input
                                        type="number"
                                        min="1"
                                        max={table.getPageCount()}
                                        value={table.getState().pagination.pageIndex + 1}
                                        onChange={e => {
                                            const page = e.target.value ? Number(e.target.value) - 1 : 0
                                            table.setPageIndex(page)
                                        }}
                                        className="border p-1 rounded w-16"
                                    />
                                </span>
                            </div>
                        </Col>
                        <Col className='flex-grow-0 mt-2 align-items-center' >
                            <Row className='px-3 flex-nowrap justify-content-end'>
                                <button
                                    className="border rounded ms-2 btn btn-primary btn-sm"
                                    style={{ minWidth: '60px', maxWidth: '60px' }}
                                    onClick={() => table.setPageIndex(0)}
                                    disabled={!table.getCanPreviousPage()}
                                >
                                    {'| <'}
                                </button>

                                <button
                                    className="border rounded ms-2 btn btn-primary btn-sm"
                                    style={{ minWidth: '60px', maxWidth: '60px' }}
                                    onClick={() => table.previousPage()}
                                    disabled={!table.getCanPreviousPage()}
                                >
                                    {'<'}
                                </button>
                                <button
                                    className="border rounded ms-2 btn btn-primary btn-sm"
                                    style={{ minWidth: '60px', maxWidth: '60px' }}
                                    onClick={() => table.nextPage()}
                                    disabled={!table.getCanNextPage()}
                                >
                                    {'>'}
                                </button>
                                <button
                                    className="border rounded ms-2 btn btn-primary btn-sm"
                                    style={{ minWidth: '60px', maxWidth: '60px' }}
                                    onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                                    disabled={!table.getCanNextPage()}
                                >
                                    {'> |'}
                                </button>
                            </Row>
                        </Col>
                    </Row>
                </div> */}
            </Card.Footer>
        </Card>
    );
};

export default MasterTableUsability;